module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mt7 mh3 mh4-ns"
  }, [_c('div', {
    staticClass: "mw8-ns center"
  }, [_c('div', {
    staticClass: "tc"
  }, [_vm._v("\n      Sorry this page doesnt exists yet. \n      "), _c('router-link', {
    staticClass: "color-theme",
    attrs: {
      "to": "/"
    }
  }, [_vm._v("Go to our home page")]), _vm._v(" "), (_vm.loggedIn) ? _c('span', [_vm._v(" or \n        "), _c('router-link', {
    staticClass: "color-theme",
    attrs: {
      "to": "/"
    }
  }, [_vm._v("go to your account dashboard.")])], 1) : _vm._e()], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-af7dc52e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/404.vue
// module id = 499
// module chunks = 0